import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "label-container" }
const _hoisted_3 = { class: "label-container" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }

import { computed } from 'vue'

import { TripCheckIn } from '@/models/checkIn'
import { TripFull } from '@/models/trip'

import { normalizeFalsy } from '@/helpers/strings'
import { normalizeUserName } from '@/helpers/user'

import DescriptionImage from './DescriptionImage.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckInItem',
  props: {
    trip: {},
    checkIn: {}
  },
  setup(__props: any) {

const props = __props

const isHost = computed(() => props.trip.host_id === props.checkIn.user_id)

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createBlock(_component_el_descriptions, {
    border: "",
    align: "top",
    column: 2,
    direction: "vertical",
    class: "description-container",
    title: `${isHost.value ? 'Host' : 'Renter'} check-in: ${_ctx.checkIn.id}`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions_item, { width: "50%" }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value ? 'Host' : 'Renter'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeUserName)(isHost.value ? _ctx.trip.host : _ctx.trip.renter)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { width: "50%" }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value ? 'Person matches' : 'Car matches'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.profile_match)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value
            ? 'Keys and ownership permit are given'
            : 'Keys and ownership permit are received'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.keys_ownership_permit)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Completed")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.checkIn.completed), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Letter of attorney ")
        ])),
        default: _withCtx(() => [
          (_ctx.checkIn.letter_of_attorney)
            ? (_openBlock(), _createBlock(DescriptionImage, {
                key: 0,
                xl: 6,
                lg: 6,
                md: 8,
                images: [_ctx.checkIn.letter_of_attorney]
              }, null, 8, ["images"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.letter_of_attorney)), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { "class-name": "dashboard-container" }, {
        label: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Dashboard ")
        ])),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, " Odometer value: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.odometer_value)), 1),
          _createElementVNode("div", _hoisted_3, " Fuel amount: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.fuel_amount)), 1),
          (_ctx.checkIn.dashboard_image)
            ? (_openBlock(), _createBlock(DescriptionImage, {
                key: 0,
                xl: 6,
                lg: 6,
                md: 8,
                images: [_ctx.checkIn.dashboard_image]
              }, null, 8, ["images"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, " Dashboard photo: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkIn.dashboard_image)), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Pre-trip pictures of the vehicle ")
        ])),
        default: _withCtx(() => [
          (_ctx.checkIn.vehicle_images && _ctx.checkIn.vehicle_images.length)
            ? (_openBlock(), _createBlock(DescriptionImage, {
                key: 0,
                images: _ctx.checkIn.vehicle_images.map(item => item.secure_url)
              }, null, 8, ["images"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, " not set "))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})